import axios from "axios";
import {BaseResponse} from "../../BaseResponse";
import {TankCheck} from "./postTankCheckList";

export async function putTankCheckList(tankCheckList: TankCheck[]) {
    const response = await axios.put<BaseResponse<boolean>>(`/tank/check`, tankCheckList)

    return response.data
}
